const {
  appendPath
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate appendPathBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  const requireAllValues = await evaluateSource(source.requireAllValues, content, parentContentPath, transientContext, nativeFunctions);
  if (requireAllValues === true && values.some(item => item === undefined)) {
    return undefined;
  }
  return values.reduce((acc, value) => acc === undefined ? value : appendPath(acc, value), undefined);
};
module.exports = {
  evaluate
};